import { IncidentInterface, ShiftInterface } from "@type/workMonitor.types"
import axios from "axios"
const ROOT_PATH = "reports"
class ReportService {
	static generateReport = (URL: string, report: any) => axios.post(URL, report, { responseType: "blob" })

	static generateShiftSummaryReport = async (shift: ShiftInterface) =>
		axios.post(`${ROOT_PATH}/shift-events-summary-report`, { shift, type: "pdf" }, { responseType: "blob" })

	static generateShiftActivityReport = async (shift: ShiftInterface) =>
		axios.post(`${ROOT_PATH}/shift-activity-report`, { shift, type: "pdf" }, { responseType: "blob" })

	static generateIncidentReport = async (incident: IncidentInterface) =>
		axios.post(`${ROOT_PATH}/incident-report`, { incident, type: "pdf" }, { responseType: "blob" })
}

export default ReportService
